module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks-layout text-dark"
  }, [_c('div', {
    staticClass: "tasks-header"
  }, [_c('div', {
    staticClass: "tasks-header__left"
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['task_names'],
      "tags": _vm.taskNameLabels,
      "selectedTags": _vm.selectedFilterTaskNames
    },
    on: {
      "select": _vm.toggleFilterTaskNames,
      "clear": function($event) {
        _vm.selectedFilterTaskNames = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['brick_type'],
      "tags": _vm.filterLabels,
      "selectedTags": _vm.selectedFilterSubjectTypes
    },
    on: {
      "select": _vm.toggleFilterSubjectTypes,
      "clear": function($event) {
        _vm.selectedFilterSubjectTypes = []
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['tasks_status'],
      "tags": _vm.taskStatusFilters,
      "selectedTags": _vm.selectedFilterTaskStatus
    },
    on: {
      "select": _vm.toggleFilterTaskStatus,
      "clear": function($event) {
        _vm.selectedFilterTaskStatus = []
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tasks-header__right"
  }, [(_vm.isSubmittingTask) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{ arrow: true, placement: 'bottom' }"
    }],
    staticClass: "do-bttn do-bttn--menu-button",
    attrs: {
      "content": "Download til excel",
      "disabled": _vm.isDownloading || !_vm.activeGroupData
    },
    on: {
      "click": _vm.asyncLoadXLSXAndDownload
    }
  }, [(_vm.isDownloading) ? _c('span', {
    staticClass: "do-spinner do-spinner--small"
  }) : _c('span', {
    staticClass: "icon-download"
  })]), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "isCloseOnDropdownClick": true,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn do-bttn--menu-button",
          class: {
            'do-bttn--active': _vm.bulkActionMode
          }
        }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['bulk_actions']) + " "), _c('span', {
          staticClass: "icon-menu-open"
        })])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', {
          staticClass: "do-bttn--menu-button__list"
        }, [_c('li', {
          on: {
            "click": function($event) {
              return _vm.startBulkAction('subject_type')
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['change_type']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'subject_type') ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.startBulkAction('hours')
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['change_hours']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'hours') ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.startBulkAction('dates')
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['change_dates']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'dates') ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.startBulkAction('delete')
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['delete_subjects']) + "\n              "), (_vm.bulkActionMode && _vm.bulkActionType === 'delete') ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "isCloseOnDropdownClick": false,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn do-bttn--menu-button"
        }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['view']) + " "), _c('span', {
          staticClass: "icon-menu-open"
        })])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', {
          staticClass: "do-bttn--menu-button__list"
        }, [_c('li', {
          on: {
            "click": function($event) {
              _vm.showCalendarInTable = !_vm.showCalendarInTable
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_calendar_in_table']) + "\n              "), (_vm.showCalendarInTable) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              _vm.showDatesInTable = !_vm.showDatesInTable
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_dates_in_table']) + "\n              "), (_vm.showDatesInTable) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              _vm.showUsersInTable = !_vm.showUsersInTable
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_users_in_table']) + "\n              "), (_vm.showUsersInTable) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              _vm.showTotalInTable = !_vm.showTotalInTable
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['show_total_in_table']) + "\n              "), (_vm.showTotalInTable) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              _vm.unmergeTasks = !_vm.unmergeTasks
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale]['unmerge_tasks']) + "\n              "), (_vm.unmergeTasks) ? _c('span', {
          staticClass: "icon-checkmark-circle"
        }) : _vm._e()])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.openCreateTask
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['create_tasks']) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tasks-body"
  }, [_c('div', {
    staticClass: "tasks-sidebar",
    class: {
      'tasks-sidebar--collapsed': _vm.sidebarCollapsed
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [(!_vm.sidebarCollapsed) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['tasks_label']) + " (" + _vm._s(_vm.filteredGroupedTasks.length) + " " + _vm._s(_vm.i18n[_vm.locale]['of']) + " " + _vm._s(_vm.totalGroupCount) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.sidebarCollapsed) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit sidebar-create-btn",
    on: {
      "click": _vm.openCreateTask
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sidebar-collapse-btn",
    on: {
      "click": function($event) {
        _vm.sidebarCollapsed = !_vm.sidebarCollapsed
      }
    }
  }, [_c('span', {
    class: _vm.sidebarCollapsed ? 'icon-arrow-right4' : 'icon-arrow-left4'
  })])]), _vm._v(" "), (!_vm.sidebarCollapsed) ? [(_vm.filteredGroupedTasks.length > 0) ? _c('ul', {
    staticClass: "sidebar-list"
  }, [_c('li', {
    staticClass: "sidebar-item",
    class: {
      'sidebar-item--active': _vm.activeGroupName === '__all__'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveGroup('__all__')
      }
    }
  }, [_c('span', {
    staticClass: "sidebar-name"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['all']))]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-count"
  }, [_vm._v(_vm._s(Math.round(_vm.allFilteredWeightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])]), _vm._v(" "), _vm._l((_vm.filteredGroupedTasks), function(group) {
    return _c('li', {
      key: group.name,
      staticClass: "sidebar-item",
      class: {
        'sidebar-item--active': _vm.activeGroupName === group.name
      },
      on: {
        "click": function($event) {
          return _vm.setActiveGroup(group.name)
        }
      }
    }, [_c('span', {
      staticClass: "sidebar-name"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('span', {
      staticClass: "sidebar-count"
    }, [_vm._v(_vm._s(Math.round(group.weightedHours * 10) / 10) + " " + _vm._s(_vm.i18n[_vm.locale]['hours_short']))])])
  })], 2) : _c('div', {
    staticClass: "sidebar-empty"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['no_tasks']))])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tasks-main"
  }, [(_vm.activeGroupData) ? [(_vm.bulkActionMode) ? _c('div', {
    staticClass: "bulk-action-bar"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.toggleSelectAllVisible
    }
  }, [_vm._v("\n          " + _vm._s(_vm.allVisibleSelected ? _vm.i18n[_vm.locale]['deselect_all'] : _vm.i18n[_vm.locale]['select_all_visible']) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bulk-action-bar__count"
  }, [_vm._v(_vm._s(_vm.selectedRowIds.length) + " " + _vm._s(_vm.i18n[_vm.locale]['selected']))]), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'subject_type') ? [_c('label', {
    staticClass: "bulk-action-bar__label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_type']) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkSubjectType),
      expression: "bulkSubjectType"
    }],
    staticClass: "do-select d-input bulk-action-bar__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bulkSubjectType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['choose_type_placeholder']))]), _vm._v(" "), _vm._l((_vm.bulkSubjectTypeOptions), function(opt) {
    return _c('option', {
      key: opt.value,
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isApplyingBulk
    },
    attrs: {
      "disabled": !_vm.bulkSubjectType || _vm.isApplyingBulk
    },
    on: {
      "click": _vm.applyBulkSubjectType
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['apply']) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'hours') ? [_c('label', {
    staticClass: "bulk-action-bar__label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_hours']) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.bulkHours),
      expression: "bulkHours",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "d-input bulk-action-bar__input",
    attrs: {
      "type": "number",
      "placeholder": _vm.i18n[_vm.locale]['hours_placeholder'],
      "min": "0",
      "step": "0.25"
    },
    domProps: {
      "value": (_vm.bulkHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bulkHours = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isApplyingBulk
    },
    attrs: {
      "disabled": _vm.bulkHours == null || _vm.bulkHours === '' || _vm.isApplyingBulk
    },
    on: {
      "click": _vm.applyBulkHours
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['apply']) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'dates') ? [_c('label', {
    staticClass: "bulk-action-bar__label"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['change_dates']) + ":")]), _vm._v(" "), _c('DatePickerRange', {
    attrs: {
      "startdate": _vm.bulkFromDate,
      "enddate": _vm.bulkToDate,
      "minDate": _vm.bulkDateMin,
      "maxDate": _vm.bulkDateMax,
      "maxEndDate": _vm.bulkDateMax,
      "allowSameDate": true
    },
    on: {
      "startchanged": _vm.setBulkFromDate,
      "endchanged": _vm.setBulkToDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isApplyingBulk
    },
    attrs: {
      "disabled": !_vm.bulkFromDate || !_vm.bulkToDate || _vm.isApplyingBulk
    },
    on: {
      "click": _vm.applyBulkDates
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['apply']) + "\n          ")])] : _vm._e(), _vm._v(" "), (_vm.selectedRowIds.length > 0 && _vm.bulkActionType === 'delete') ? [(_vm.skippedSubjectCount > 0) ? _c('span', {
    staticClass: "bulk-action-bar__warning"
  }, [_vm._v("\n            " + _vm._s(_vm.skippedSubjectCount) + " " + _vm._s(_vm.i18n[_vm.locale]['bulk_delete_skipped']) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--delete",
    class: {
      'do-bttn--submit--loading': _vm.isApplyingBulk
    },
    attrs: {
      "disabled": _vm.deletableSubjectIds.length === 0 || _vm.isApplyingBulk
    },
    on: {
      "click": _vm.applyBulkDelete
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['delete']) + " (" + _vm._s(_vm.deletableSubjectIds.length) + ")\n          ")])] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn bulk-action-bar__cancel",
    on: {
      "click": _vm.cancelBulkAction
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['cancel']) + "\n        ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "task-table-wrap"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [(_vm.bulkActionMode) ? _c('th', {
    staticClass: "task-table-checkbox",
    staticStyle: {
      "width": "36px"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allVisibleSelected
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSelectAllVisible.apply(null, arguments)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "220px"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['hours']))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['type']))]), _vm._v(" "), (_vm.showCalendarInTable) ? _c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['calendar']))]) : _vm._e(), _vm._v(" "), (_vm.showDatesInTable) ? _c('th', {
    staticStyle: {
      "width": "180px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['dates']))]) : _vm._e(), _vm._v(" "), (_vm.showUsersInTable) ? _c('th', {
    staticStyle: {
      "min-width": "250px"
    }
  }, [_c('span', {
    staticClass: "icon-user3"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['users']))]) : _vm._e(), _vm._v(" "), (_vm.showTotalInTable) ? _c('th', {
    staticClass: "d-table__number",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['total']))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px"
    }
  })])]), _vm._v(" "), _c('tbody', [(_vm.activeGroupName !== '__all__') ? _c('tr', {
    staticClass: "task-table-row task-table-row--add",
    on: {
      "click": _vm.duplicateFromGroup
    }
  }, [_c('td', {
    attrs: {
      "colspan": _vm.visibleColumnCount
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['new_task']))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeGroupData.tasks), function(task) {
    return _c('tr', {
      key: task._generatedId || task.id
    }, [(_vm.bulkActionMode) ? _c('td', {
      staticClass: "task-table-checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isRowSelected(task)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleRowSelection(task)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "task__name"
    }, [_c('div', {
      class: [{
        'td-subject--hidden': !task.can_schedule
      }, {
        'td-subject': task.can_schedule
      }],
      style: ({
        'background-color': task.color
      }),
      on: {
        "click": function($event) {
          return _vm.setEditTask(task)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(task.name || '') + "\n                  ")])])]), _vm._v(" "), _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(task.hours ? parseFloat(task.hours.toFixed(2)) : 0))]), _vm._v(" "), _c('td', {
      staticClass: "task-table-type"
    }, [_vm._v(_vm._s(_vm.getTaskTypeLabel(task)))]), _vm._v(" "), (_vm.showCalendarInTable) ? _c('td', {
      staticClass: "task-table-calendar",
      class: {
        'task-table-calendar--own': task.in_user_calendar
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getTaskCalendarLabel(task)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showDatesInTable) ? _c('td', {
      staticClass: "task-table-dates"
    }, [_vm._v("\n                " + _vm._s(_vm.getTaskDatesLabel(task)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.showUsersInTable) ? _c('td', {
      class: {
        'd-select-lookalike': _vm.activeDSelect !== (task._generatedId || task.id) && (task.user_calendar_ids || []).length < 1
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDSelect(task)
        }
      }
    }, [(_vm.activeDSelect === (task._generatedId || task.id)) ? _c('DSelectCalendarIds', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.closeDSelect),
        expression: "closeDSelect"
      }],
      attrs: {
        "show": _vm.activeDSelectShow,
        "itemType": "USER",
        "preSelectedItems": task.user_calendar_ids || [],
        "itemsThatCantBeDeleted": _vm.getUsersWithEvents(task),
        "showTags": true,
        "sortSelectedByName": true
      },
      on: {
        "update": function($event) {
          return _vm.setTableSelectedUsers($event, task)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.activeDSelect !== (task._generatedId || task.id) && (task.user_calendar_ids || []).length > 0) ? _c('div', {
      staticClass: "task__users"
    }, _vm._l((_vm.getUserNames(task.user_calendar_ids || [])), function(name) {
      return _c('p', {
        key: name
      }, [_vm._v(_vm._s(name))])
    }), 0) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showTotalInTable) ? _c('td', {
      staticClass: "d-table__number"
    }, [_vm._v(_vm._s(_vm.getTaskWeightedTotal(task)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "task-table-actions"
    }, [_c('button', {
      staticClass: "task-table-copy",
      attrs: {
        "title": _vm.i18n[_vm.locale]['create_copy']
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.duplicateTask(task)
        }
      }
    }, [_vm._v("+")])])])
  })], 2)])])] : _c('div', {
    staticClass: "main-empty"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['select_task']))])], 2)]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
    attrs: {
      "editTask": _vm.editTask,
      "activeFilter": null,
      "prefill": _vm.prefillTask,
      "quickCreate": _vm.isQuickCreate,
      "isLoadingFreshData": _vm.isLoadingFreshTask
    },
    on: {
      "close": _vm.closeCreateTask,
      "create": _vm.createTask
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abff5332!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionTasksFromSubjects.vue
// module id = 2085
// module chunks = 1